export default __webpack_public_path__ + "media/images/dashboard_icons/event-coordinator-fdb079c09993aa84dd05f31d2aafeb77.svg";